import React from 'react';
import { Theme } from '@material-ui/core';
import { createStyles, makeStyles } from '@material-ui/core/styles';
import { useNavigate } from 'react-router-dom';

import { Closing, ClosingProps } from '@bizapp-lp/workflow/organisms/Closing';
import { FAQ, FAQProps } from '@bizapp-lp/workflow/organisms/FAQ';
import { Feature } from '@bizapp-lp/workflow/organisms/Feature';
import { FirstView } from '@bizapp-lp/workflow/organisms/FirstView';
import { Footer } from '@bizapp-lp/workflow/organisms/Footer';
import { Header } from '@bizapp-lp/workflow/organisms/Header';
import {
  HeaderContent,
  HeaderContentDrawer,
} from '@bizapp-lp/workflow/organisms/HeaderMenu';
import { Overview } from '@bizapp-lp/workflow/organisms/Overview';
import { Plan, PlanProps } from '@bizapp-lp/workflow/organisms/Plan';

const useStyle = makeStyles((theme: Theme) =>
  createStyles({
    nav: {
      marginLeft: 'auto',
    },
    mainButton: {
      height: theme.spacing(4),
      width: theme.spacing(20),
      display: 'inline',
    },
    links: {
      color: '#636363',
      fontSize: '14px',
      letterSpacing: 0,
      marginRight: theme.spacing(3),
      marginLeft: 0,
      display: 'inline-flex',
      alignItems: 'center',
      '&:link': { color: '#333333' },
      '&:visited': { color: '#333333' },
      '&:action': {
        color: '#333333',
        textDecoration: 'underline',
      },
      '&:focus': {
        color: '#333333',
        textDecoration: 'underline',
      },
      '&:hover': {
        color: '#333333',
        textDecoration: 'underline',
      },
    },
    overview: {
      marginTop: 'calc(-100vw / 10)',
      paddingTop: 'calc(100vw / 6 + 16px)',
      paddingBottom: theme.spacing(8),
    },
    feature: {
      paddingTop: theme.spacing(10),
      paddingBottom: theme.spacing(10),
    },
    plan: {
      marginTop: theme.spacing(-25),
    },
    faq: {
      marginTop: 'calc(-100vw / 10)',
      paddingTop: 'calc(100vw / 6 + 48px)',
      paddingBottom: theme.spacing(8),
    },
    closing: {
      backgroundColor: '#f2f3fb',
    },
  }),
);

export interface HomeProps {
  faq?: Omit<FAQProps, 'className'>;
  plan?: Omit<PlanProps, 'className'>;
  closing?: Omit<ClosingProps, 'className'>;
}

const Home: React.FC<HomeProps> = ({ faq, plan, closing }) => {
  const classes = useStyle();
  const navigate = useNavigate();

  const [width, setWidth] = React.useState(window.innerWidth);
  React.useEffect(() => {
    const updateSize = () => {
      setWidth(window.innerWidth);
    };
    window.addEventListener('resize', updateSize);
    return () => window.removeEventListener('resize', updateSize);
  }, []);

  const headerContent = {
    links: [
      {
        url: '/workflow/contact',
        label: 'お問い合わせ',
      },
    ],
    label: '資料ダウンロード',
    onClick: () => navigate('/workflow/document-claim'),
  };

  return (
    <>
      <Header from="workflow">
        {width >= 768 ? (
          <HeaderContent {...headerContent} />
        ) : (
          <HeaderContentDrawer {...headerContent} />
        )}
      </Header>
      <main>
        <FirstView />
        <Overview className={classes.overview} />
        <Feature className={classes.feature} />
        <Plan className={classes.plan} {...plan} />
        <FAQ className={classes.faq} {...faq} />
        <Closing className={classes.closing} {...closing} />
      </main>
      <Footer />
    </>
  );
};

export default Home;
